import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HueRotate extends BaseOption {
  static userInterfaceComponent = {
    label: "Hue Rotate",
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      min: 0,
      append: "deg",
    },
  };

  static defaultValue = 0;

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === 0 || configValue === undefined || configValue === "") {
      return 0;
    }
    return `${configValue}deg`;
  }
}
